// utils/version-check.js
import { HTTP_URI } from '../api/api'
const VERSION_CONFIG = {
    LOCAL_KEY: 'app_version',        // 本地存储的版本号key
    REFRESH_FLAG_KEY: 'has_refreshed', // 标记本次会话是否已刷新过
    API_URL: HTTP_URI.BASEURL + '/paper-version.json', // 'https://paper.bixuange.com/paper-version.json'//'https://paperspotlight.com/paper-version.json'
  };
  
  /**
   * 获取远程版本号
   */
  async function fetchRemoteVersion() {
    const response = await fetch(VERSION_CONFIG.API_URL, {
      cache: 'no-cache',
      headers: { 'Cache-Control': 'no-cache' }
    });
    
    if (!response.ok) {
      throw new Error(`HTTP ${response.status}`);
    }
    
    const data = await response.json();
    return data.version;
  }
  
  /**
   * 检查版本并决定是否刷新
   * @param {boolean} isAutoCheck - 是否为定时自动检查（true: 自动检查, false: 初始加载）
   * @returns {Promise<boolean>} - 是否执行了刷新
   */
  export async function checkVersionAndRefresh(isAutoCheck = false) {
    try {
      // 获取远程版本
      const remoteVersion = await fetchRemoteVersion();
      console.log(`[版本检查] 远程版本: ${remoteVersion}, 是否为定时检查: ${isAutoCheck}`);
      
      // 获取本地存储的版本
      const localVersion = localStorage.getItem(VERSION_CONFIG.LOCAL_KEY);
      console.log(`[版本检查] 本地版本: ${localVersion || '无'}`);
      
      // 获取本次会话是否已经刷新过的标记
      const hasRefreshed = sessionStorage.getItem(VERSION_CONFIG.REFRESH_FLAG_KEY) === 'true';
      
      // 判断版本是否一致
      const needUpdate = !localVersion || localVersion !== remoteVersion;
      
      if (!needUpdate) {
        console.log('[版本检查] 版本一致，无需刷新');
        return false;
      }
      
      // 版本不一致，需要更新
      console.log('[版本检查] 检测到版本不一致');
      
      // 如果已经刷新过，不再重复刷新
      if (hasRefreshed) {
        console.log('[版本检查] 本次会话已刷新过，跳过自动刷新');
        // 强制更新本地版本号，避免反复提示
        localStorage.setItem(VERSION_CONFIG.LOCAL_KEY, remoteVersion);
        return false;
      }
      
      // 执行刷新
      console.log('[版本检查] 即将刷新页面...');
      // 保存新版本号到本地
      localStorage.setItem(VERSION_CONFIG.LOCAL_KEY, remoteVersion);
      // 标记本次会话已刷新
      sessionStorage.setItem(VERSION_CONFIG.REFRESH_FLAG_KEY, 'true');
      // 刷新页面（true表示强制从服务器重新加载）
      window.location.reload(true);
      return true;
      
    } catch (error) {
      console.error('[版本检查] 失败:', error);
      return false;
    }
  }